var _circle, _ellipse, _rect, _circle2, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _circle3, _circle4, _path, _path2, _ellipse7, _path3, _ellipse8, _ellipse9, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#E8F4FD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 195,
    rx: 65,
    ry: 45,
    fill: "#4A90D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 125,
    width: 30,
    height: 25,
    fill: "#F5D0C5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 85,
    r: 50,
    fill: "#F5D0C5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 55,
    rx: 45,
    ry: 30,
    fill: "#5D4E37"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 70,
    rx: 12,
    ry: 20,
    fill: "#5D4E37"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 70,
    rx: 12,
    ry: 20,
    fill: "#5D4E37"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 90,
    rx: 8,
    ry: 9,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 90,
    rx: 8,
    ry: 9,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 91,
    r: 4,
    fill: "#3D3D3D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 91,
    r: 4,
    fill: "#3D3D3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 78 Q80 74 90 78",
    stroke: "#5D4E37",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 78 Q120 74 130 78",
    stroke: "#5D4E37",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 105,
    rx: 4,
    ry: 6,
    fill: "#E8C4B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85 115 Q100 125 115 115",
    stroke: "#D49C8C",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68,
    cy: 105,
    rx: 8,
    ry: 5,
    fill: "#F8C8C8",
    opacity: 0.5
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132,
    cy: 105,
    rx: 8,
    ry: 5,
    fill: "#F8C8C8",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 150 L85 165 L100 155 L115 165 L130 150",
    stroke: "#3A7BC8",
    strokeWidth: 2,
    fill: "#4A90D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.951ff3396b0e234c7714bf4362954208.svg";
export { ForwardRef as ReactComponent };